import { webKnots } from '../../../common/back/lace/webKnots'
import { jointOfCatchFace } from './parts/earJointParts'
import { laceOfAroundIndexFinger, laceOfAroundThumbFinger } from './parts/laceParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const wt7Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  laceOfAroundThumbFinger(ctx, laceColor, 8, -2)
  laceOfAroundThumbFinger(ctx, laceColor, -12, 14)
  laceOfAroundThumbFinger(ctx, laceColor, -30, 28)
  laceOfAroundThumbFinger(ctx, laceColor, -54, 43)
  laceOfAroundThumbFinger(ctx, laceColor, -74, 62)

  laceOfAroundIndexFinger(ctx, laceColor, 8, -15)
  laceOfAroundIndexFinger(ctx, laceColor, -5, 2)
  laceOfAroundIndexFinger(ctx, laceColor, -18, 27)
  laceOfAroundIndexFinger(ctx, laceColor, -30, 54)
  laceOfAroundIndexFinger(ctx, laceColor, -42, 85)
  laceOfAroundIndexFinger(ctx, laceColor, -53, 120)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // バスケットのデザインここから
  ctx.beginPath()
  ctx.moveTo(562, 120) // 左上
  ctx.quadraticCurveTo(534, 166, 509, 237) // 左下
  ctx.quadraticCurveTo(536, 281, 581, 326) // 右下
  ctx.quadraticCurveTo(632, 289, 667, 254) // 右上
  ctx.quadraticCurveTo(634, 172, 562, 120) // 左上
  // ctx.fill()
  // 区切りライン 横方向
  ctx.moveTo(550, 140) // 左上
  ctx.quadraticCurveTo(613, 190, 652, 267) // 左下
  ctx.moveTo(540, 160) // 左上
  ctx.quadraticCurveTo(595, 205, 636, 281) // 左下
  ctx.moveTo(530, 184) // 左上
  ctx.quadraticCurveTo(576, 227, 619, 297) // 左下
  ctx.moveTo(519, 212) // 左上
  ctx.quadraticCurveTo(561, 253, 599, 310) // 左下
  ctx.stroke()
  // 区切りライン 縦方向
  ctx.moveTo(590, 143) // 上
  ctx.quadraticCurveTo(520, 254, 520, 254) // 下
  ctx.moveTo(614, 168) // 上
  ctx.quadraticCurveTo(535, 272, 535, 272) // 下
  ctx.moveTo(638, 198) // 上
  ctx.quadraticCurveTo(550, 292, 550, 292) // 下
  ctx.moveTo(655, 228) // 上
  ctx.quadraticCurveTo(568, 311, 568, 311) // 下
  ctx.stroke()
  ctx.closePath()
  // バスケットのデザインここまで

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 内側
  ctx.moveTo(555, 87) // 左上
  ctx.quadraticCurveTo(511, 166, 489, 252) // 左下
  ctx.quadraticCurveTo(505, 313, 581, 355) // 右下
  ctx.quadraticCurveTo(624, 326, 687, 274) //
  ctx.quadraticCurveTo(660, 155, 555, 87) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  laceOfAroundIndexFinger2(ctx, laceColor, 10, -20)
  laceOfAroundIndexFinger2(ctx, laceColor, 0, 0)
  laceOfAroundIndexFinger2(ctx, laceColor, -13, 25)
  laceOfAroundIndexFinger2(ctx, laceColor, -26, 50)
  laceOfAroundIndexFinger2(ctx, laceColor, -35, 80)
  laceOfAroundIndexFinger2(ctx, laceColor, -48, 115)
  laceOfAroundIndexFinger(ctx, laceColor, -50, 131)
  laceOfAroundThumbFinger2(ctx, laceColor, 3, 2)
  laceOfAroundThumbFinger2(ctx, laceColor, -20, 20)
  laceOfAroundThumbFinger2(ctx, laceColor, -35, 33)
  laceOfAroundThumbFinger2(ctx, laceColor, -57, 48)
  laceOfAroundThumbFinger2(ctx, laceColor, -79, 62)
  laceOfAroundThumbFinger(ctx, laceColor, -80, 65)
}

const laceOfAroundIndexFinger2 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(534 + x, 100 + y) // 左上
  ctx.quadraticCurveTo(537 + x, 105 + y, 537 + x, 108 + y) // 左下1
  ctx.quadraticCurveTo(542 + x, 106 + y, 544 + x, 123 + y) // 右下1
  ctx.quadraticCurveTo(549 + x, 130 + y, 552 + x, 123 + y) // 右上
  ctx.quadraticCurveTo(552 + x, 102 + y, 534 + x, 100 + y) // 左上
  ctx.fill()
  ctx.moveTo(537 + x, 104 + y) // 左上
  ctx.quadraticCurveTo(545 + x, 105 + y, 545 + x, 123 + y) // 右下1
  ctx.stroke()
  ctx.closePath()
}

const laceOfAroundThumbFinger2 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(664 + x, 273 + y) // 左上
  ctx.quadraticCurveTo(659 + x, 274 + y, 662 + x, 282 + y) // 左下1
  ctx.quadraticCurveTo(673 + x, 285 + y, 683 + x, 290 + y) // 右下1
  ctx.quadraticCurveTo(690 + x, 287 + y, 689 + x, 283 + y) // 右上
  ctx.quadraticCurveTo(675 + x, 271 + y, 664 + x, 273 + y) // 左上
  ctx.fill()
  ctx.moveTo(662 + x, 281 + y) // 左下
  ctx.quadraticCurveTo(673 + x, 279 + y, 685 + x, 289 + y) // 右下1
  ctx.stroke()
  ctx.closePath()
}
